exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".badge-3-wrapper[data-v-ba7dbb10]{width:235px;padding-bottom:10px}.bottom-border[data-v-ba7dbb10]{width:calc(100% + 3px);margin-bottom:-2px;margin-top:10px;margin-left:-1px;color:#fff;padding:2px;text-align:center;font-size:12px}.listing-img[data-v-ba7dbb10]{width:50px;height:50px;border-radius:50%;display:inline-block}", ""]);

// exports
